import type { History } from 'history';
import type { MouseEvent } from 'react';
import { IBase64Attachment } from '../../../features/salesOrder/types';

export const SERVICE_FORM_INITIAL_FOCUS_ID = 'service-form-initial-focus';

export const focusServiceFormInitialField = (): boolean => {
	const el = document.getElementById(SERVICE_FORM_INITIAL_FOCUS_ID);
	if (!(el instanceof HTMLElement)) {
		return false;
	}
	el.focus();
	return document.activeElement === el;
};

export const test = (): number => 1;

export const generateSalesOrderUrl = (salesOrderId: string, serviceId?: string, agencyId?: number): string => {
	const params = new URLSearchParams();
	if (serviceId) params.set('serviceId', serviceId);
	if (agencyId) params.set('agencyId', String(agencyId));
	const query = params.toString();
	const baseUrl = `/salesorder/${salesOrderId}`;
	return query ? `${baseUrl}?${query}` : baseUrl;
};

export const generatePaymentsUrl = (salesOrderId: string, lineId?: string): string => {
	const baseUrl = `/salesorder/${salesOrderId}?section=payments`;
	return lineId ? `${baseUrl}&lineId=${lineId}` : baseUrl;
};

export const openPaymentsUrl = (history: History, saleOrderId: string, lineId?: string, event?: MouseEvent): void => {
	const url = generatePaymentsUrl(saleOrderId, lineId);
	if (event?.ctrlKey || event?.metaKey) {
		event.preventDefault();
		window.open(url, '_blank', 'noopener,noreferrer');
		return;
	}
	history.push(url);
};

export const openSaleOrderServiceUrl = (
	history: History,
	saleOrderId: string,
	serviceId: string,
	event?: MouseEvent,
	agencyId?: number,
): void => {
	const url = generateSalesOrderUrl(saleOrderId, serviceId, agencyId);
	if (event?.ctrlKey || event?.metaKey) {
		event.preventDefault();
		window.open(url, '_blank', 'noopener,noreferrer');
		return;
	}
	history.push(url);
};

export function fileToBase64Attachment(file: File): Promise<IBase64Attachment> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = () => {
			const result = reader.result as string;
			// result = "data:application/pdf;base64,JVBERi0xLjcKJ..."

			const base64 = result.split(',')[1]; // solo el base64 puro

			resolve({
				fileName: file.name,
				contentType: file.type || 'application/octet-stream',
				base64,
				sizeBytes: file.size,
			});
		};

		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}
